// extracted by mini-css-extract-plugin
module.exports = {"button":"Button_button__2Lf63","loading":"Button_loading__2nORI"};